type Choice = Readonly<{
  id: number
  name: string
  fee: string
}>

type Props = Readonly<{
  choices: readonly Choice[]
  selectedId?: number
  onChange: (id: number) => void
}>

const CheckoutShippingMethods = ({ choices, selectedId, onChange }: Props) => {
  return (
    <ul>
      {
        choices.map(choice => (
          <li key={ choice.id }>
            <label>
              <input
                type="radio"
                name="checkout-shipping-method"
                value={ choice.id }
                checked={ selectedId === choice.id }
                onChange={ () => { onChange(choice.id) } }
              />
              <span className="checkout-shipping-method-name">{ choice.name }</span>
              <span className="checkout-shipping-method-fee">{ choice.fee }</span>
            </label>
          </li>
        ))
      }
    </ul>
  )
}

export { CheckoutShippingMethods }
